module.exports = __webpack_public_path__ + "static/img/portrait-female.71823fda.png";